import { default as ByzantineAddress } from "byzantine/src/Address";
import { AddressAutocompleteInput as CeruleanAddressAutocompleteInput } from "cerulean";
import { Control, Controller, FieldValues, Path } from "react-hook-form";
import type { AddressAutocompleteUpdateHandler } from "cerulean/src/AddressAutocompleteInput";

interface AddressAutocompleteInputProps<T extends FieldValues> {
  control: Control<T, unknown>;
  name: Path<T>;
  label: string;
  onUpdate: (address: ByzantineAddress) => void;
}
function AddressAutocompleteInput<T extends FieldValues>(props: AddressAutocompleteInputProps<T>) {
  const { control, name, label, onUpdate } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
        <CeruleanAddressAutocompleteInput
          label={label}
          onChange={onChange}
          onBlur={onBlur}
          value={value ?? ""}
          error={error?.message}
          onUpdate={(address: Parameters<AddressAutocompleteUpdateHandler>[0]) =>
            onUpdate(new ByzantineAddress(address))
          }
        />
      )}
    />
  );
}

export { AddressAutocompleteInput };
